// extracted by mini-css-extract-plugin
module.exports = {"body":"index-module--body--16Mmh","container":"index-module--container--2opHa","mainWrapper":"index-module--mainWrapper--1RevU"};